module.exports = __webpack_public_path__ + "annualreview2017/static/img/women@0,5x.f551023.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/people/women@0,5x.jpg
// module id = 775
// module chunks = 0